import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';

//Styles
import cs from '../../../components/commonStyle.css';
import s from './ViewInformationRecords.css';

const ViewTableBodyInformation = ({ title, linkData, currencyData, value, linkText, amount, convertCurrency, isMinus, pricingData, isBold }) => {
    return (
        <div className={cx(s.titleText, s.p16, cs.displayGrid, cs.gridCols2, s.borderTop, cs.gridColsMobile1, cs.gap4)}>
            <div className={cx(isBold && cs.fontWeightSemiBold)}>{title}</div>
            {value && <div>{value}</div>}
            {linkData && <div><a href={linkData} target="_blank"> {linkText}</a></div>}
            {currencyData && <div className={cx(isBold && cs.fontWeightSemiBold)}>
                {isMinus && '-'}
                <CurrencyConverter amount={amount} from={convertCurrency} />
            </div>}
            {pricingData && pricingData()}
        </div>
    )
}

ViewTableBodyInformation.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string,
    linkData: PropTypes.string,
    currencyData: PropTypes.string,
    linkText: PropTypes.string,
    amount: PropTypes.number,
    convertCurrency: PropTypes.string,
    isMinus: PropTypes.bool
}

export default injectIntl(withStyles(cs, s)(ViewTableBodyInformation));